module.exports = __webpack_public_path__ + "sunm.svg?8b9a1bfcd0880c689ea75673741a4a93";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sunm.svg
// module id = 764
// module chunks = 0